import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
// #562: a language picked here is the USER's choice: saved on the user (PUT /users/me/language), not just in this browser.
// WAS (#535, until #562): import { dilSecimiKaydet } from '../../services/dilVarsayilani'; (a per-browser "chose" flag)
import { saveMyLanguageChoice } from '../../services/kullaniciDilService';

// Public klasöründeki bayraklara giden yolları belirliyoruz
const languages = {
    tr: { flag: `${process.env.PUBLIC_URL}/tr.png`, label: 'Türkçe' },
    en: { flag: `${process.env.PUBLIC_URL}/us.png`, label: 'English' }
};

const LanguageDropdown = ({ selectedLang, setSelectedLang }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const changeLanguageAction = (langKey) => {
    // WAS (#535, until #562): dilSecimiKaydet();
    setSelectedLang(langKey);
    // The UI has switched already; the save is not waited for. Logged out (login / public pages): nothing to save.
    saveMyLanguageChoice(langKey);
  };

  const get = (object, path) => path.split('.').reduce((o, p) => o ? o[p] : '', object);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" tag="button">
        <img
          src={get(languages, `${selectedLang}.flag`)}
          alt="Header Language"
          height="20"
          className="rounded"
        />
      </DropdownToggle>
      <DropdownMenu className="notify-item language py-2">
        {Object.keys(languages).map(key => (
          <DropdownItem
            key={key}
            onClick={() => changeLanguageAction(key)}
            className={`notify-item ${selectedLang === key ? "active" : "none"}`}
          >
            <img
              src={get(languages, `${key}.flag`)}
              alt={languages[key].label}
              className="me-2 rounded"
              height="18"
            />
            <span className="align-middle">
              {languages[key].label}
            </span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageDropdown;
